module.exports = __webpack_public_path__ + "static/img/OM3.77e2e765.png";